import React, { Component } from 'react';
import { MessageBox } from '@eg/elements/MessageBox';
import "./Outcomes.scss";

class NotFound extends Component {
  render() {
    return (
      <div className="esc_container outerContainer">
        <div className="esc_container esc_container--l"id="main-outcomes-container">
          <div>
            <MessageBox>
              <h2>404 – Die von Ihnen angeforderte Seite konnte leider nicht gefunden werden.</h2>
                <a id="linkStartpage" href="/internet-schutzbrief">Zurück zur Startseite</a>
            </MessageBox>
          </div>
        </div>
      </div>
    )
  }
}

export default NotFound;
